import { endpoints } from "../../../config";
import appClient from "../../common/services/AppClient";
import { PublishedReport, ReportParameter } from "../types";

export default class ReportsService {
    uriPrefix = endpoints.tasksUrl + "reports";
    reportsAdminUrl = endpoints.reportsUrL;

    async getReports() {
        const resp = await appClient.get<PublishedReport[]>(this.uriPrefix);
        return resp.mapErr((err) => new Error(err.data?.title));
    }

    async publishReport(formData: FormData) {
        return appClient.post<string>(this.uriPrefix, formData);
    }

    async updateReport(reportId: string, formData: FormData) {
        const url = this.uriPrefix + `/${reportId}`;
        return appClient.update<string>(url, formData);
    }

    async deleteReport(reportId: string) {
        const url = this.uriPrefix + `/${reportId}`;
        const resp = await appClient.delete<string>(url);
        return resp.mapErr((err) => new Error(err.data?.title));
    }

    async toggleReportAvailability(reportId: string) {
        const url = this.uriPrefix + `/toggle/${reportId}`;
        const resp = await appClient.patch<string>(url);
        return resp.mapErr((err) => new Error(err.data?.title));
    }

    async getParameters(clientId: string, report: string) {
        const url = `${this.reportsAdminUrl}clients/${clientId}/parameters`;
        const body = {
            report,
        };
        const resp = await appClient.post<ReportParameter[]>(url, body);
        return resp.mapErr((err) => new Error(err.data?.title));
    }

    async getClients() {
        const url = `${this.reportsAdminUrl}clients`;
        const resp = await appClient.post<{ clientId: string }>(url);
        return resp.mapErr((err) => new Error(err.data?.title));
    }
}
